import React from "react";
import styles from "./Table.module.css";
import { classed } from "@frend-digital/ui";

export const TableContainer = classed.div(styles.Container);

export const TableScrollContainer = classed.div(styles.ScrollContainer);

export const Table = classed.table(styles.Table);

export const TableHead = classed.thead(styles.TableHead);

export const TableRow = classed.tr(styles.TableRow);

export const TableBody = classed.tbody(styles.TableBody);

export const TableCell = classed.td(styles.TableCell);

export const TableHeader = classed.th(styles.TableHeader);
